import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import state from './state';
import mutations from './mutations';

export const serviceComputed = {
	...mapState('dicMsgManagementStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('dicMsgManagementStore', Object.keys(actions)),
	...mapMutations('dicMsgManagementStore', Object.keys(mutations))
};
